import get from 'lodash/get';

const getUserEvals = concept => get(concept, 'evaluations.evaluations', []);

export default getUserEvals;
